module.exports = __webpack_public_path__ + "media/images/rank_01-f35a37e3dc57d7daec61361c871f396e.png";